module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('seo-title', {
    attrs: {
      "content": _vm.$t('index.meta.title')
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": _vm.$t('index.meta.description')
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-keywords', {
    attrs: {
      "content": "webplatform, software, softwareudvikling, deveo, deveodk, deveo aps, vue, javascript, laravel, php, packages, open source"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": _vm.$t('index.meta.title')
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": _vm.$t('index.meta.description')
    }
  }), _vm._v(" "), _c('seo-og-image', {
    attrs: {
      "content": "/static/images/opengraph/fb_og.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-gradient top-panel skew"
  }, [_c('div', {
    staticClass: "container inside-skew"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-xs-12"
  }, [_c('h3', {
    staticClass: "header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.mainHeader'))), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "index-typer"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('index.firstService')) + "\n                        ")])]), _vm._v(" "), _c('p', {
    staticClass: "breadtext"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.mainText')) + "\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-light btn-rounded",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Contact'
      },
      "href": "#"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.mainContactButton')) + "\n                    ")])], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white",
    staticStyle: {
      "margin-top": "-200px",
      "padding-top": "260px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 header-box",
    attrs: {
      "align": "right"
    }
  }, [_c('h3', [_vm._v("\n                        " + _vm._s(_vm.$t('index.subHeaderFirst'))), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('index.subHeaderSecond')) + "\n                    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.subText')) + "\n                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "simple-link",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Technology'
      },
      "href": "#"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.subButton')) + " "), _c('i', {
    staticClass: "ion-arrow-right-c"
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light index-cases",
    staticStyle: {
      "margin-bottom": "60px",
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "bow",
    attrs: {
      "src": "/static/images/layout/bow.png",
      "alt": "bow"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container outer-cases-small"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.$t('index.casesHeader')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fix-width"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('index.casesText')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "customer-wrapper row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "case quooker"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/quooker.svg",
      "alt": "Quooker"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "casetext"
  }, [_c('b', [_vm._v("\"")]), _vm._v("\n                            " + _vm._s(_vm.$t('index.quookerStatement')) + "\n                            "), _c('b', [_vm._v("\"")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('section', {
    staticClass: "index-iceberg"
  }, [_c('img', {
    staticClass: "arch",
    attrs: {
      "src": "/static/images/layout/arch-bottom.svg",
      "alt": "Arch"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "icebergwater"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "titanic-container",
    style: ({
      left: _vm.titanic.x + 'px'
    })
  }, [_c('img', {
    staticClass: "titanic",
    attrs: {
      "src": "/static/images/iceberg/titanic.svg",
      "alt": "Titanic"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('index.icebergHeader')))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('index.icebergText')) + "\n                    ")])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('section', {
    staticClass: "cta-section"
  }, [_c('div', {
    staticClass: "container cta-container"
  }, [_c('div', {
    staticClass: "row cta-background"
  }, [_c('div', {
    staticClass: "col-lg-6 index-contact-cta"
  }, [_c('h3', [_vm._v("\n                        " + _vm._s(_vm.$t('index.ctaHeader')) + "\n                        "), _c('span', [_vm._v(_vm._s(_vm.$t('index.ctaSubheader')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "cta-buttons"
  }, [_c('router-link', {
    staticClass: "cta-button",
    attrs: {
      "tag": "button",
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('index.ctaFirstButton')) + "\n                        ")])], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-7 index-devices"
  }, [_c('div', {
    staticClass: "device",
    attrs: {
      "id": "vw-device"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing/vw_new.svg",
      "alt": "Volkswagen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "device",
    attrs: {
      "id": "quooker-device"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing/quooker-shop-vertical-landing.svg",
      "alt": "Quooker"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "device",
    attrs: {
      "id": "atea-device"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing/mobilswap-horizontal-landing.svg",
      "alt": "Mobilswap"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('span', {
    staticClass: "ion-ios-color-wand-outline"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Niclas Correll")]), _c('br'), _vm._v("\n                            Quooker Skandinavien A/S\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case half f2d"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/f2d.png",
      "alt": "FRESH2DEATH"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case half vw"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/volkswagen_large.svg",
      "alt": "Volkswagen"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "case large semler"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/semler.png",
      "alt": "Semler Retail A/S"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case large julehjaelpen"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/julehjaelpen.svg",
      "alt": "Julehjælpen"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "case prominds"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/prominds.png",
      "alt": "Prominds"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case large fclarsen"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/fclarsen.png",
      "alt": "FC Larsen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case sepeeg"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/sepeeg.png",
      "alt": "SEPEEG"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "cloud-container"
  }, [_c('div', {
    staticClass: "cloud"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('img', {
    staticClass: "iceberg-main",
    attrs: {
      "src": "/static/images/iceberg/main.svg",
      "alt": "Iceberg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f5fd683"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/index/pages/index.vue
// module id = 309
// module chunks = 1